  
import GSAP from 'gsap'

interface RAF {
  scrollCallback: (time) => void
  canvasCallback: () => void
  callbacks: {
    name: string
    callback: (time) => void
  }[]
}

class RAF {

  constructor() {
    this.callbacks = []
    this.bind()
  }

  init() {
    GSAP.ticker.fps(60)
    GSAP.ticker.add(this.render)
  }

  subscribeScroll(callback : (time) => void) {
    this.scrollCallback = callback
  }

  subscribeCanvas(callback : () => void) {
    this.canvasCallback = callback
  }

  subscribe(name : string, callback : (time) => void) {
    this.callbacks.push({
      name: name,
      callback: callback
    })
  }
  
  unsubscribe(name : string) {
    this.callbacks.forEach((item, i) => {
      if (item.name == name) this.callbacks.splice(i, i + 1)
    })
  }
  
  render(time, deltaTime, frame) {
    this.scrollCallback?.(time)
    this.callbacks.forEach(item => item.callback(time) )
    this.canvasCallback?.()
  }

  bind() {
    this.render = this.render.bind(this)
  }
}

const _instance = new RAF()
export default _instance